<template>
	<mdb-row class="mt-4">
		<arrange :col="arrangeCol" role="Filter"></arrange>
		<arrange :col="arrangeCol" role="Projection"></arrange>
		<!-- <arrange :col="col" role="Graph"></arrange> -->
		<edit :col="editCol" class="overflow-xl-hidden"></edit>
	</mdb-row>
</template>

<script>
import Arrange from '@/components/properties/Arrange'
import Edit from '@/components/properties/Edit'

export default {
	name: 'PropertiesIndex',
	components: { Arrange, Edit },
	computed: {
		arrangeCol () {
			return { col: '6', xl: '3' }
		},
		editCol () {
			return { col: '12', xl: '6' }
		}
	}
}
</script>
